import React from 'react';
import Avatar from 'material-ui/Avatar';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { GetApp } from 'material-ui-icons'

import * as filedownload from '../../../actions/fileupload';

import UpdateFile from './updatefile';
import DeleteFile from './deletefile';

class CardMenu extends React.Component {

    render() {
        const ITEM_HEIGHT = 40;
        const options = [
            { id: 1, name: 'View / Update' },
            { id: 2, name: 'Delete' }
        ];
        const { menuState, anchorEl, handleRequestClose } = this.props;
        return (
            <Menu id="long-menu"
                anchorEl={anchorEl}
                open={menuState}
                onClose={handleRequestClose}
                style={{ maxHeight: ITEM_HEIGHT * 4.5 }}
                MenuListProps={{
                    style: {
                        width: 150,
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                }}>
                {options.map(option =>
                    option.id == 2 || this.props.fileId ? <MenuItem key={option.id} onClick={handleRequestClose.bind(this, option.id)}>
                        {option.name}
                    </MenuItem> : null,
                )}
            </Menu>
        );
    }

}

const DragHandle = SortableHandle(() =>
    <i className="zmdi zmdi-menu draggable-icon" style={{ fontSize: 25 }} />);

class TableCell extends React.Component {

    onOptionMenuSelect = event => {
        this.setState({ menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose(data, click_id, e) {
        // console.log('handleClick', click_id);
        if (click_id == 1) {
            this.setState({ openDialog: true });
        }
        else if (click_id == 2) {
            // this.setState({open: true});
            this.setState({ openDeleteDialog: true });
        }
        else if (click_id == 3) {
            // this.setState({open: true});
        }
        else if (click_id == 4) {
            // console.log(this.props)
            // this.props.history.push('/user/add-user/' + userid);
        }
        this.setState({ menuState: false });
    };

    downloadFile(e) {
        this.props.actions.fileDownloadAgendaItem(this.props.data)
    };
    closeDialog = (data) => {
        this.setState({ openDialog: false });
        this.setState({ openDeleteDialog: false });
    }

    getUpdateFileDetails = (data) => {
        // console.log('tablecell=>',data)
        this.props.getUpdateFileDetails(data);
        this.setState({ openDialog: false });
    }
    getDeleteFileDetails = (data) => {
        // console.log('tablecell=>',data)
        this.props.getDeleteFileDetails(data);
        this.setState({ openDeleteDialog: false });
    }

    constructor() {
        super();
        this.state = {
            anchorEl: undefined,
            menuState: false,
            openDialog: false,
            openDeleteDialog: false,
        }
    }

    render() {
        const { anchorEl, menuState } = this.state;
        const { description, fileName } = this.props.data;
        const index = this.props.i;
        // console.log(this.props)
        return (
            <tr tabIndex={-1} key={index}>
                <td>{this.props.data.fileId ? <DragHandle /> : null}</td>
                <td>{this.props.i + 1}</td>
                <td>{fileName}</td>
                <td>{description}</td>
                <td className="text-right">
                    {this.props.data.fileId ? <IconButton className="m-3 size-30" onClick={this.downloadFile.bind(this)}>
                        <GetApp /></IconButton> : null}
                    <IconButton className="size-30" onClick={this.onOptionMenuSelect.bind(this)}>
                        <i className="zmdi zmdi-more-vert" /></IconButton>
                    <CardMenu menuState={menuState} anchorEl={anchorEl} fileId={this.props.data.fileId}
                        handleRequestClose={this.handleRequestClose.bind(this, this.props.data)} />
                    <UpdateFile open={this.state.openDialog} data={this.props.data} agendaid={this.props.id}
                        closeDialog={this.closeDialog} getUpdateFileDetails={this.getUpdateFileDetails}
                        committee_id={this.props.committee_id} />
                    <DeleteFile open={this.state.openDeleteDialog} data={this.props.data} agendaid={this.props.id}
                        closeDialog={this.closeDialog} getDeleteFileDetails={this.getDeleteFileDetails} />

                </td>
            </tr>
        );
    }
}

function mapStateToProps(state) {
    return state;
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(filedownload, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SortableElement(TableCell)));


// WEBPACK FOOTER //
// ./app/agendaitemdetails/addagendaitem/tablecell.js